import { registerHandler } from '../paymentHandlerRegistry';

const YAPE_PHONE_NUMBER = /^\d{9}$/;
const YAPE_OTP = /^\d{6}$/;

/**
 * Whether the Yape form can be charged.
 * `isValid` alone is not enough: YapeForm reports valid as soon as one field was blurred without an
 * error, so a buyer who fills the phone and never touches the code passes with `otp: ''`. The digit
 * rules are the ones useYapeValidation applies to each field.
 * @param {object} [yapeForm] - Yape form state from usePaymentSection.
 * @returns {boolean} True when the phone and the one-time code are complete and valid.
 */
const isYapeFormComplete = (yapeForm) => {
  const { formData, isValid } = yapeForm || {};
  return Boolean(
    isValid && YAPE_PHONE_NUMBER.test(formData?.phoneNumber) && YAPE_OTP.test(formData?.otp),
  );
};

/**
 * Yape payment handler.
 * Handle MercadoPago Yape (`otp`) payments the way `Checkout.handleYapePayment` does: warn on an
 * incomplete form, otherwise dispatch the Yape payment with the phone and one-time code.
 */
registerHandler('otp', {
  execute: async ({ yapeForm, onFormFail, onYapePaymentAttempt }) => {
    if (!isYapeFormComplete(yapeForm)) {
      onFormFail();
      return;
    }
    await onYapePaymentAttempt(yapeForm.formData);
  },
});
